import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { on_product_name } from '../../../utils/gtag';

type MenuNavigation = {
	selectProduct(id: string, name: string, product_group: string): void;
	selectProductGroup(id: string): void;
};

export const useMenuNavigation = (currentGroupId?: string): MenuNavigation => {
	const navigate = useNavigate();

	const selectProductGroup = useCallback(
		(id: string) => {
			window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

			navigate(String(id));
		},
		[navigate]
	);

	const selectProduct = useCallback(
		(id: string, name: string, product_group: string) => {
			if (currentGroupId) {
				on_product_name({
					product_name: name,
					product_category: product_group
				});
				window.scrollTo({ top: 0, left: 0, behavior: 'auto' });

				navigate(
					`product/${id}/${name.toLowerCase().split(' ').join('-')}`
				);
			}
		},
		[currentGroupId, navigate]
	);

	return {
		selectProduct,
		selectProductGroup
	};
};
